import { zodResolver } from '@hookform/resolvers/zod'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import ActionButton from '@repo/ui/action-button'
import { Save2Icon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useForm } from 'react-hook-form'
import z, { ZodType } from 'zod'

import { MissionTrackingExceptionalBonusInput } from '../../../lib/types/models/mission-tracking/mission-tracking-input'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'

const formSchema: ZodType<MissionTrackingExceptionalBonusInput> = z.object({
  exceptionalBonusAmount: createNumberSchema('prime exceptionnelle', { nullish: true }),
  exceptionalBonusReason: createStringSchema('motif exceptionnel', { nullish: true })
})

type Props = {
  isLoading?: boolean
  defaultValues?: Partial<MissionTrackingExceptionalBonusInput>
  onSubmit: (data: MissionTrackingExceptionalBonusInput) => void
}

const MissionTrackingExceptionalBonusForm: React.FC<Props> = ({
  isLoading,
  defaultValues,
  onSubmit
}) => {
  const form = useForm<MissionTrackingExceptionalBonusInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className={'bg-white-hover p-3 rounded-xl'}>
          <Typography variant="tag" color={tailwindColors.primary.DEFAULT}>
            Prime exceptionnelle
          </Typography>

          <div className={'flex flex-row gap-3 mt-3'}>
            <FormField
              control={form.control}
              name="exceptionalBonusReason"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledInput
                      {...field}
                      type="text"
                      label="Label"
                      labelClassName="bg-white-hover"
                    />
                  </FormControl>
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="exceptionalBonusAmount"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormControl>
                    <ControlledInput
                      {...field}
                      type="number"
                      label="Montant (€)"
                      labelClassName="bg-white-hover"
                    />
                  </FormControl>
                </FormItem>
              )}
            />

            <ActionButton
              type={'submit'}
              variant={'ghost'}
              icon={Save2Icon}
              isLoading={isLoading}
            />
          </div>
        </div>
      </form>
    </Form>
  )
}

export default MissionTrackingExceptionalBonusForm
